export default "/fonts/vendor/katex/dist/KaTeX_Main-Bold.woff2?39890742bc957b368704509bb2f4163c";